import { useApi } from 'app/context';
import { useBasePaginatedList } from './useBasePaginatedList';
import { IPatientSchema } from 'generated/axios';
import { useCallback, useEffect } from 'react';

export const usePatientList = () => {
  const { patientApi } = useApi();

  const {
    list,
    page,
    handlePageChange,
    pageSize,
    handlePageSizeChange,
    count,
    loading,
    setLoading,
    filter,
    handleFilter,
    handleError,
    handleSuccess,
  } = useBasePaginatedList<IPatientSchema>();

  const get = useCallback(() => {
    setLoading(true);
    patientApi
      .webPaginatePatients(page, pageSize, filter)
      .then((resp) => {
        if (resp.status >= 400) {
          return Promise.reject(resp);
        }
        handleSuccess(resp.data.results, resp.data.total);
      })
      .catch((err) => {
        handleError(err);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientApi, page, pageSize, filter]);

  useEffect(() => {
    get();
  }, [get]);

  const importCSV = (file: File) => {
    setLoading(true);
    patientApi
      .webImportPatientsCSV(file)
      .then((resp) => {
        if (resp.status >= 400) {
          return Promise.reject(resp);
        }
        get();
      })
      .catch((err) => {
        handleError(err);
      })
      .finally(() => setLoading(false));
  };

  const refresh = () => get();

  return {
    list,
    page,
    handlePageChange,
    pageSize,
    handlePageSizeChange,
    count,
    loading,
    handleFilter,
    refresh,
    importCSV,
  };
};
